export const subtitles = {
    "1": {
        "startTime": 2.128,
        "endTime": 3.777,
        "transcript": "Taumek apciiqamken.",
        "translation": "I will ask you about that."
    },
    "2": {
        "startTime": 3.79,
        "endTime": 8.633,
        "transcript": "Qaillun-kiq waniw' piniarcia? Nalluvagcia. Elisngassiyaanripagcia.",
        "translation": "I wonder how I'll do it? I don't know. I don't know too much about it."
    },
    "3": {
        "startTime": 8.64,
        "endTime": 10.975,
        "transcript": "Assirtuq tamakut answer-aaten.",
        "translation": "Your answers are good."
    },
    "4": {
        "startTime": 10.989,
        "endTime": 11.883,
        "transcript": "Oh okay.",
        "translation": "Oh, okay."
    },
    "5": {
        "startTime": 12.986,
        "endTime": 14.21,
        "transcript": "Taringamken.",
        "translation": "I understand you."
    },
    "6": {
        "startTime": 14.225,
        "endTime": 14.772,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "7": {
        "startTime": 18.171,
        "endTime": 20.313,
        "transcript": "Qanemcillren ava-i waniw'",
        "translation": "The story you just told"
    },
    "8": {
        "startTime": 22.363,
        "endTime": 26.654,
        "transcript": "Qanrutellren wangkutnun ava-i pillren,",
        "translation": "What you just said to us,"
    },
    "9": {
        "startTime": 27.127,
        "endTime": 35.896,
        "transcript": "Makut kenkesqelluki waniw' ikiungraameng. Cauniarta-kiq akiliuteq ircaqumteggun?",
        "translation": "How we should treat others with love though they are bad. What would be the reward for our hearts?"
    },
    "10": {
        "startTime": 36.245,
        "endTime": 43.804,
        "transcript": "Ircaqumteggun akiliutii kinguqvaarni assirluku.",
        "translation": "The reward for our hearts will be good in the future."
    },
    "11": {
        "startTime": 43.804,
        "endTime": 51.828,
        "transcript": "Uitanqegciluta uitallerkarput akiliutngungaciiqliniuq. Iciw' yuk...",
        "translation": "It seems that our reward will be that we will live in peace. You know, a person..."
    },
    "12": {
        "startTime": 53.545,
        "endTime": 59.631,
        "transcript": "Avani-gguq yuut ciuqvaarni tamana tamaa-i cali qanruyutelleq yuut tamarmeng",
        "translation": "They said that people long ago, there is also traditional wisdom that all people"
    },
    "13": {
        "startTime": 62.192,
        "endTime": 65.695,
        "transcript": "Elluarlluteng ilait piksaitelallruyaaqlilriit.",
        "translation": "Some of them probably do not live right."
    },
    "14": {
        "startTime": 66.213,
        "endTime": 70.238,
        "transcript": "Caunrilkinritellerkaq uiminek tamaa-i.",
        "translation": "That is how one shouldn't disparage their husband."
    },
    "15": {
        "startTime": 71.746,
        "endTime": 77.121,
        "transcript": "Kinguqvaarni uitanqegciluta assirluta uitallerkarput.",
        "translation": "So that we will be able to live peacefully in the future."
    },
    "16": {
        "startTime": 79.308,
        "endTime": 80.408,
        "transcript": "Yaa.",
        "translation": "I see."
    },
    "17": {
        "startTime": 89.797,
        "endTime": 95.088,
        "transcript": "Tua-i arcaqalria qanrusken. Camek cali allamek pirkaituten?",
        "translation": "You've said the important thing. Do you have anything else?"
    },
    "18": {
        "startTime": 95.387,
        "endTime": 100.094,
        "transcript": "Wiinga au͡gna wiinga iciw'",
        "translation": "Personally, you know"
    },
    "19": {
        "startTime": 100.395,
        "endTime": 106.988,
        "transcript": "Avani ciuqvaarni ayuqucillerput tangerrluku, waniwa-llu cali ayuqucirput",
        "translation": "Looking at how we were back then, and how we are now"
    },
    "20": {
        "startTime": 107.025,
        "endTime": 110.959,
        "transcript": "Wiinga amllerqunek takumcuyulartua ayagyuanek.",
        "translation": "Many times, I pity young people."
    },
    "21": {
        "startTime": 112.209,
        "endTime": 120.967,
        "transcript": "Iciw' takaunateng-wa tua-i wall'u-wa yuucurlagluteng pilriit.",
        "translation": "You know, they act in socially unacceptable ways, or they are leading bad lives."
    },
    "22": {
        "startTime": 121.387,
        "endTime": 124.502,
        "transcript": "Akusrarnarqellriit cumigulluki.",
        "translation": "They focus on misbehavior."
    },
    "23": {
        "startTime": 125.412,
        "endTime": 128.713,
        "transcript": "Tamakut wiinga takumcuklaranka iciw'.",
        "translation": "I pity those, you know?"
    },
    "24": {
        "startTime": 132.171,
        "endTime": 138.274,
        "transcript": "Akusrarrlua anglillrunrilama. Akusrarrlua anglillrunritua.",
        "translation": "Because I didn't grow up mischievous. I didn't grow up mischievous."
    },
    "25": {
        "startTime": 139.365,
        "endTime": 145.173,
        "transcript": "Assiinii-llu iliini assiitelangerma assiini,",
        "translation": "And being bad, even though I was bad sometimes,"
    },
    "26": {
        "startTime": 145.935,
        "endTime": 149.67,
        "transcript": "Irniamnun aanaulleq takaqaqa.",
        "translation": "I treat being a mother to my children with respect."
    },
    "27": {
        "startTime": 149.873,
        "endTime": 155.137,
        "transcript": "Assirlua tau͡gaam yuuyuglua umyuarteq'laama.",
        "translation": "Because I only have my mind on wanting to live well."
    },
    "28": {
        "startTime": 155.305,
        "endTime": 159.396,
        "transcript": "Maa-i mat'um nalliini takumcuyulartua ayagyuanek",
        "translation": "These days, I pity young people"
    },
    "29": {
        "startTime": 159.676,
        "endTime": 166.515,
        "transcript": "Qanruyutnek-wa tua-i nallulrianek tua-i-wa qanrutkumayuilata.",
        "translation": "Those that do now know traditional wisdom because they are not spoken about."
    },
    "30": {
        "startTime": 166.871,
        "endTime": 176.862,
        "transcript": "Waten tau͡gaam man'a calillertek KYUK-kun alaitaqluteng Yupiit qalarucilaqata",
        "translation": "But with your work with KYUK like this, if they show Yupiit speaking [about traditional teachings]"
    },
    "31": {
        "startTime": 178.576,
        "endTime": 181.43,
        "transcript": "Tamaa-i assilriamek caliciquci.",
        "translation": "You will do good work."
    },
    "32": {
        "startTime": 182.35,
        "endTime": 187.157,
        "transcript": "Man'a-llu man'a-wa Yugturrlainaq pivkenaku",
        "translation": "And not doing this only in Yup'ik"
    },
    "33": {
        "startTime": 187.489,
        "endTime": 200.509,
        "transcript": "Kass'atun, Kass'atun mumiggluku makut ayagyuaput qitevquralriit taringevkarluki pikuvci assilriamek caliciquci.",
        "translation": "In English, if you translate it into English so that the young people who only speak English will understand, you will do good work."
    },
    "34": {
        "startTime": 200.551,
        "endTime": 204.246,
        "transcript": "Tamaa-i arcaqalria wiinga qanruteksukeka.",
        "translation": "That's the important thing I want to say."
    },
    "35": {
        "startTime": 204.983,
        "endTime": 210.175,
        "transcript": "Man'a Yugni piciryaraput mixed-aucamta watua maa-i.",
        "translation": "Our Yup'ik ways, since we are being mixed today."
    },
    "36": {
        "startTime": 210.294,
        "endTime": 215.418,
        "transcript": "Nulirqellriit Yugglainaunritut. Kass'anek aipangqertut.",
        "translation": "Married couples are not all Yup'ik. They have Caucasian spouses."
    },
    "37": {
        "startTime": 215.923,
        "endTime": 221.91,
        "transcript": "Kass'at-llu aipait tamakut taringyunarqut wangkuta Yup'igni",
        "translation": "Their Caucasian spouses also need to understand how we Yupiit"
    },
    "38": {
        "startTime": 222.344,
        "endTime": 229.908,
        "transcript": "Qaillun assirluta nulirqutlerkaput. Kass'at-llu elicugngaat.",
        "translation": "How we would be good married couples. Caucasians can learn it too."
    },
    "39": {
        "startTime": 231.997,
        "endTime": 239.552,
        "transcript": "Qanruyutet aliartaqluki pinaciaqsaunaki.",
        "translation": "Show the traditional wisdom without delay."
    },
    "40": {
        "startTime": 239.832,
        "endTime": 250.72,
        "transcript": "Uuggun KYUK-kun wall' tiiviikun amlleqapiaraata watua nulirqellriit elluarrluteng quyungqanrilnguut ayagyuat.",
        "translation": "Through KYUK or TV, since there are a lot of married couples now, young people, who are not gathered right."
    },
    "41": {
        "startTime": 252.116,
        "endTime": 258.906,
        "transcript": "Yaa. Au͡g'umek paqnayularyaaqua iciw',",
        "translation": "Yes. I am curious about that, you know"
    },
    "42": {
        "startTime": 258.906,
        "endTime": 267.54,
        "transcript": "Ciin-gguq mikelnguut aananun caumanrulartat aatanun pivkenateng?",
        "translation": "Why are children more attached to mothers, not fathers?"
    },
    "43": {
        "startTime": 268.021,
        "endTime": 278.632,
        "transcript": "Aanat enem iluani uitauratuut, aatat-llu anluteng ayagatuluteng, pissurluteng, caliluteng.",
        "translation": "Mothers stay in the house, and the fathers go out to travel, hunt, and work."
    },
    "44": {
        "startTime": 278.789,
        "endTime": 282.659,
        "transcript": "Aanani wangkuta irniamta caunganrularaitkut,",
        "translation": "Our children are more attached to us mothers"
    },
    "45": {
        "startTime": 282.659,
        "endTime": 286.23,
        "transcript": "Wangkuta home-ami uitauralaamta.",
        "translation": "Because we stay at home."
    },
    "46": {
        "startTime": 286.433,
        "endTime": 296.583,
        "transcript": "Neqkiurteńguluta, aturait iqairluki, aulukluki tua-i family-put. Aanani wangkuta important-aartukut home-ami.",
        "translation": "We prepare food, wash their clothes, take care of our families. We mothers are important in the home."
    },
    "47": {
        "startTime": 296.94,
        "endTime": 303.3,
        "transcript": "Taumek irniani, irniat angayuqateng niisngakunegteki,",
        "translation": "That's why if children are obedient to their parents,"
    },
    "48": {
        "startTime": 303.496,
        "endTime": 308.808,
        "transcript": "Aanateng-ll' una arcaqerluku niisngakunegtegu assirciquq.",
        "translation": "And if they're especially obedient to their mothers, it will be good."
    },
    "49": {
        "startTime": 309.177,
        "endTime": 316.192,
        "transcript": "Aanameggnek niisngainrilnguut aanaitni akngirqelartut.",
        "translation": "Those who are disobedeint to their mothers, their mothers get hurt."
    },
    "50": {
        "startTime": 316.712,
        "endTime": 321.376,
        "transcript": "Aanat amllermek calirpagtut home-ami.",
        "translation": "Mother work hard on a lot of things in the home."
    },
    "51": {
        "startTime": 321.675,
        "endTime": 326.522,
        "transcript": "Irniat tua-i tamalkuita aulukluki, kenekluki-ll' tamalkuita.",
        "translation": "They take care of all of their children, and love them all."
    },
    "52": {
        "startTime": 326.871,
        "endTime": 330.697,
        "transcript": "Man'a tau͡gken irniam aanagni",
        "translation": "However, a child who [disobeys] their parents"
    },
    "53": {
        "startTime": 330.921,
        "endTime": 334.629,
        "transcript": "Narurtaaqunikek aanau͡rluat",
        "translation": "If he keeps disobeying them, their poor mother"
    },
    "54": {
        "startTime": 334.678,
        "endTime": 338.734,
        "transcript": "Akngirtaqluni ircaqumikun. Tamana assirpek'nani.",
        "translation": "Her heart will be hurt. That's not good."
    },
    "55": {
        "startTime": 339.112,
        "endTime": 348.402,
        "transcript": "Aaniit yuut takuatgun irniami takuatgun qiangaicaaquq, nalluatgun tau͡gaam qiagaqluni, akngirrluni ircaqumikun.",
        "translation": "Their mother would not cry in front of her children, but cry without their knowledge, hurting in her heart."
    },
    "56": {
        "startTime": 348.443,
        "endTime": 357.61,
        "transcript": "Tua-i-wa irniani aanateng narurtaaqunegteki tamaaggun aanateng nangciiqliniat.",
        "translation": "If their children keeps disobeying their parents, they will make their mother suffer through that."
    },
    "57": {
        "startTime": 358.213,
        "endTime": 361.598,
        "transcript": "Man'a aanauyaraq cakneq angtuaruuq.",
        "translation": "Being a mother is extremely important."
    },
    "58": {
        "startTime": 363.457,
        "endTime": 367.595,
        "transcript": "Man'a-llu maa-i aanauyaraq",
        "translation": "And being a mother"
    },
    "59": {
        "startTime": 368.767,
        "endTime": 376.21,
        "transcript": "Yugni amllerni Kass'ani-llu makuni ayagyuani nallunricunaqluni.",
        "translation": "Many people, even among these Caucasians, these young people need to know it."
    },
    "60": {
        "startTime": 376.486,
        "endTime": 384.447,
        "transcript": "Aanateng qigcikluki umyugait navgurpek'naki pikuneng tamaa-i assirluteng yuuciqut.",
        "translation": "If they respect their mothers without destorying their mental health, they will live well."
    },
    "61": {
        "startTime": 384.744,
        "endTime": 390.292,
        "transcript": "Amta-llu qigcikevkenaki pikuneng assiinateng yuuluteng",
        "translation": "Yet if they do not respect them, they will lead bad lives"
    },
    "62": {
        "startTime": 390.668,
        "endTime": 395.708,
        "transcript": "Akusrarrluteng cat makut aturyugluki inerquutai.",
        "translation": "Misbehaving, doing the things she admonishes against."
    },
    "63": {
        "startTime": 396.779,
        "endTime": 410.829,
        "transcript": "Makut aanailnguut aatailnguut waniw' kitumek iciw' elicimarqailnguut kitumun ullagyugngaat?",
        "translation": "These children without mothers or fathers who, you know, want do not have teachers, who can they go to?"
    },
    "64": {
        "startTime": 411.032,
        "endTime": 414.889,
        "transcript": "Kinkut ullagyugngaaki nallunriryukaki?",
        "translation": "Who can they go to if they want to learn them?"
    },
    "65": {
        "startTime": 414.951,
        "endTime": 420.42,
        "transcript": "Ii-i, makut elliraat aanailnguut aatailnguut-llu,",
        "translation": "Well, these orphans without mothers and fathers"
    },
    "66": {
        "startTime": 421.142,
        "endTime": 427.63,
        "transcript": "Wiinga elliraullruama elder ciuqlirraam arnassagaam wall',",
        "translation": "Since I was an orphan, an elder, an elder lady, or"
    },
    "67": {
        "startTime": 427.721,
        "endTime": 435.463,
        "transcript": "Arnam wall' angutem old-alriim qalarutaqanga wiinga cakneq quyalallruunga.",
        "translation": "When an old woman or man taught me, I would be very thankful."
    },
    "68": {
        "startTime": 435.848,
        "endTime": 439.887,
        "transcript": "Tua-i-llu waniwa makut elliraat,",
        "translation": "And so, these orphans"
    },
    "69": {
        "startTime": 440.943,
        "endTime": 451.783,
        "transcript": "Assirluteng angliyukuneng makut ciurlirneteng Yupiit ullagluki,",
        "translation": "If they want to grow up well, they should go to their Yup'ik elders"
    },
    "70": {
        "startTime": 452.726,
        "endTime": 459.35,
        "transcript": "Camek apcugngait. Qanrucugngaaput qaillun assirluku pillerkaitnek.",
        "translation": "They can ask them something. We can tell them how they would do well."
    },
    "71": {
        "startTime": 461.482,
        "endTime": 462.455,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "72": {
        "startTime": 462.602,
        "endTime": 463.989,
        "transcript": "Yaa.",
        "translation": "You're welcome."
    },
    "73": {
        "startTime": 464.622,
        "endTime": 468.425,
        "transcript": "Cali allamek makunek apyutkangqerkuma",
        "translation": "If I have any other questions"
    },
    "74": {
        "startTime": 468.855,
        "endTime": 473.041,
        "transcript": "Niicugniurlua pikuma iciw' ilait waniwa maa-i",
        "translation": "If I listen, you know, some of them now"
    },
    "75": {
        "startTime": 474.134,
        "endTime": 477.662,
        "transcript": "Ilait iciw' nepliqallrulriit wall'u-qaa,",
        "translation": "You know, some of them had a commotion, or"
    },
    "76": {
        "startTime": 479.339,
        "endTime": 484.622,
        "transcript": "Assirluten pillruuten. Pekaavkenak pillruuten.",
        "translation": "You did well. You didn't make sudden movements."
    },
    "77": {
        "startTime": 484.657,
        "endTime": 488.482,
        "transcript": "Yaa, tuaten piqtaaryuumiilama question-aaten tangerrsullruanka.",
        "translation": "Yes, since I didn't want to do that, I wanted to see your questions."
    },
    "78": {
        "startTime": 488.5,
        "endTime": 489.803,
        "transcript": "Yaa, nutaan.",
        "translation": "Yes, that's good."
    },
    "79": {
        "startTime": 489.83,
        "endTime": 491.828,
        "transcript": "Waste-aryuumiinaku time.",
        "translation": "I didn't want to waste time."
    },
    "80": {
        "startTime": 493.199,
        "endTime": 497.035,
        "transcript": "Man'a qalartellerpuk Kass'at-llu niiskunegneki assiryarluni.",
        "translation": "It would be good if Caucasians also listened to our conversation."
    },
    "81": {
        "startTime": 498.498,
        "endTime": 503.766,
        "transcript": "Amllerrata Kass'at, half and half-nulirqellriit.",
        "translation": "Because there are a lot of Caucasians, married couples who are half [Yup'ik] and half [Caucasian]."
    },
    "82": {
        "startTime": 513.809,
        "endTime": 516.891,
        "transcript": "Rusty, don't move around.",
        "translation": "Rusty, don't move around."
    },
    "83": {
        "startTime": 516.904,
        "endTime": 518.931,
        "transcript": "You might disturb her.",
        "translation": "You might disturb her."
    },
    "84": {
        "startTime": 518.94,
        "endTime": 522.131,
        "transcript": "Nakleng, I didn't mean to be so imkuciq.",
        "translation": "Sorry, I didn't mean to be so, you know."
    },
    "85": {
        "startTime": 522.142,
        "endTime": 529.069,
        "transcript": "Tau͡gaam nepainaku qaneryagan pillruamku waniw' nepaiqurasqellruaqa.",
        "translation": "But since I told him to be quiet when he was talking, I told him to be quiet."
    },
    "86": {
        "startTime": 529.074,
        "endTime": 531.983,
        "transcript": "Canrituq. Foster kid-aqaqa.",
        "translation": "It's okay. He's my foster kid."
    },
    "87": {
        "startTime": 531.995,
        "endTime": 534.313,
        "transcript": "Qaa? Assiqtarluni.",
        "translation": "Really? He's so adorably well-behaved."
    },
    "88": {
        "startTime": 534.319,
        "endTime": 537.856,
        "transcript": "Two-aagnek pingqertua. Aipaa elitnaurtuq.",
        "translation": "I have two. The other is in school."
    },
    "89": {
        "startTime": 538.957,
        "endTime": 540.811,
        "transcript": "Qaillun tam' foster kid-aqluku?",
        "translation": "How is he your foster kid?"
    },
    "90": {
        "startTime": 540.874,
        "endTime": 542.22,
        "transcript": "Through the state?",
        "translation": "Through the state?"
    },
    "91": {
        "startTime": 542.229,
        "endTime": 545.838,
        "transcript": "Yaa. Last year pivkallruatnga.",
        "translation": "Yes.They had me do it last year."
    },
    "92": {
        "startTime": 545.839,
        "endTime": 547.329,
        "transcript": "Wanigga-ll' assirluni?",
        "translation": "And he's good now?"
    },
    "93": {
        "startTime": 554.764,
        "endTime": 556.564,
        "transcript": "Nuu, cali piqataraanga.",
        "translation": "No, she's going to [interview] me again."
    },
    "94": {
        "startTime": 556.578,
        "endTime": 558.442,
        "transcript": "This is just cutaways.",
        "translation": "This is just cutaways."
    },
    "95": {
        "startTime": 558.917,
        "endTime": 561.793,
        "transcript": "I need her to talk at length.",
        "translation": "I need her to talk at length."
    },
    "96": {
        "startTime": 562.127,
        "endTime": 562.99,
        "transcript": "For a long time?",
        "translation": "For a long time?"
    },
    "97": {
        "startTime": 565.191,
        "endTime": 566.11,
        "transcript": "Qaillun?",
        "translation": "How?"
    },
    "98": {
        "startTime": 566.11,
        "endTime": 568.528,
        "transcript": "Piciatun qanaagumaluten.",
        "translation": "Speak about random things."
    },
    "99": {
        "startTime": 569.002,
        "endTime": 570.792,
        "transcript": "Mikelnguvnek \tqanemcisnga.",
        "translation": "Tell me stories about your children."
    },
    "100": {
        "startTime": 571.185,
        "endTime": 572.212,
        "transcript": "Qaillun?",
        "translation": "How?"
    },
    "101": {
        "startTime": 572.226,
        "endTime": 576.753,
        "transcript": "Qavcinek mikelngungqercit, grandchildren-aangqercit?",
        "translation": "How many children and grandchildren do you have?"
    },
    "102": {
        "startTime": 577.237,
        "endTime": 579.683,
        "transcript": "Calallrat mikelnguten.",
        "translation": "What your children used to do."
    },
    "103": {
        "startTime": 580.206,
        "endTime": 584.37,
        "transcript": "Wiinga ten-aanek irniangqertua.",
        "translation": "I have ten children."
    },
    "104": {
        "startTime": 586.851,
        "endTime": 592.015,
        "transcript": "Tutgaraanka-wa seven-aat. Ikgetut seven-aat.",
        "translation": "I have seven grandchildren. They are few, seven."
    },
    "105": {
        "startTime": 594.017,
        "endTime": 599.662,
        "transcript": "Tamarmeng-llu taqnerurrluteng, atauciq tau͡gaam kinguqliat high school-arluni kiimi.",
        "translation": "And they've all become adults, but only one, the youngest, is in high school alone."
    },
    "106": {
        "startTime": 600.066,
        "endTime": 604.612,
        "transcript": "Tamarmeng-llu, ilait ellmeggnek pingluteng.",
        "translation": "And all of them, some of them are on their own now."
    },
    "107": {
        "startTime": 605.327,
        "endTime": 611.918,
        "transcript": "Assirluteng ellmeggnek aulukengnaqluteng.",
        "translation": "They're doing well, trying to take care of themselves."
    },
    "108": {
        "startTime": 618.429,
        "endTime": 619.284,
        "transcript": "Waqaa?",
        "translation": "What's going on?"
    },
    "109": {
        "startTime": 619.295,
        "endTime": 620.704,
        "transcript": "Nuu, cikiryaaqluku.",
        "translation": "No, I gave him something."
    },
    "110": {
        "startTime": 620.715,
        "endTime": 624.07,
        "transcript": "Oh, cingkaniryukuvgu keluqvaqaniryugngauq cali.",
        "translation": "Oh, if you want to push it more, it can go further back still."
    }
};